export const generalInputProps = { variant: 'outlined', size: 'small' } as const;
export const generalPriceInputProps = {
  ...generalInputProps,
  prefix: '$',
  allowNegative: false,
  decimalScale: 2,
  fixedDecimalScale: true,
  selectValueOnFocus: true,
} as const;
